/**
 * The Strip Card rules a pool's Settings tab shows (ISSUE-1294). Built from
 * the server's own `maxSpotsPerMember`, so the rule text always says exactly
 * what the board enforces (v1 FB-2026-10-20-5).
 */
import { stripMaxSpotsSummary } from "./stripCardCopy";

export function stripRulesText(input: {
  maxSpotsPerMember: number | null;
}): string[] {
  return [
    "Every game in this pool has its own card. A card has up to 4 strips, and every strip has 10 rows.",
    `Tap an open row to take it, and tap your own row to give it back. ${stripMaxSpotsSummary(input.maxSpotsPerMember)}`,
    "When an admin locks a strip, every row gets a digit from 0 to 9, drawn at random. Rows can't change while a strip is locked.",
    "An admin marks the winning rows, with a date and a note for each one.",
    "If a game won't be played, its card goes read only and its winners are cleared.",
  ];
}
